import { render } from "./FilesIndex.vue?vue&type=template&id=5faf6186&scoped=true"
import script from "./FilesIndex.vue?vue&type=script&lang=js"
export * from "./FilesIndex.vue?vue&type=script&lang=js"

import "./FilesIndex.vue?vue&type=style&index=0&id=5faf6186&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faf6186"]])

export default __exports__